'use client';
import {useSyncExternalStore} from 'react';

const suppressors = new Set<symbol>();
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach(listener => {
    listener();
  });
}

export function suppressMobileRegisterInterest(): () => void {
  const token = Symbol();
  suppressors.add(token);
  emit();
  return () => {
    suppressors.delete(token);
    emit();
  };
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot(): boolean {
  return suppressors.size > 0;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useMobileRegisterInterestSuppressed(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
